import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useUser } from "./context/UserContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import axios from "axios";
import Password from "./pages/Password";
import Usuarios from "./pages/Usuarios";
import { useCookies } from 'react-cookie';

const App = () => {

    const { user, login, logout } = useUser();
    const [cookies, setCookie] = useCookies();


    const [sessionValidated, setSessionValidated] = useState(false);

    useEffect(() => {
        const validateSession = async () => {
            try {
                axios.defaults.withCredentials = true;
                const response = await axios.get(
                    "https://apimedidas.ahouseinterior.com/validate_session.php",
                    { withCredentials: true }
                );
                if (response.data.status === "success") {
                    login(response.data.user); // Actualiza el contexto de usuario
                    setSessionValidated(true)
                } else {
                    logout(); // Si falla, limpia el estado del usuario
                }
            } catch (error) {
                console.error("Error al validar la sesión:", error);
                logout(); // Logout en caso de error
            }
        };


        if (!sessionValidated) {
            validateSession();
        }
    }, []);

    return (
        <Router>
            <Routes>
                <Route
                    path="/usuarios"
                    element={user && cookies.rol == "admin" ? <Usuarios /> : <Navigate to="/" />}
                />
                {/* Ruta pública para iniciar sesión */}
                <Route
                    path="/password"
                    element={user && cookies.rol != "inhabilitado" ? <Password /> : <Navigate to="/" />}
                />

                {/* Ruta protegida */}
                <Route
                    path="/dashboard"
                    element={user && cookies.rol != "inhabilitado" ? <Dashboard /> : <Navigate to="/" />}
                />
                <Route
                    path="/"
                    element={user && cookies.rol != "inhabilitado" ? <Navigate to="/dashboard" /> : <Login />}
                />
            </Routes>
        </Router>
    );
};

export default App;
